import { ContextMenuItemView, UnitContextMenuClickParams } from '@mark43/cad-api';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function EditTemporaryUnitItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: UnitContextMenuClickParams;
}): React.ReactElement {
    const drawerControls = useDrawerControls();
    return (
        <ContextMenuItem
            dataPendoId="menu-item-edit-temporary-unit"
            contextMenuItemView={contextMenuItemView}
            onSelect={() => {
                drawerControls.open({
                    type: 'edit-temporary-unit',
                    props: { unitId: clickParams.unitId },
                });
            }}
        />
    );
}
